import { Box, Paper, Typography, TextField, InputAdornment, IconButton, OutlinedInput } from "@mui/material";
import React, { useState, useEffect } from "react";

import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";

export default function EmailSetting({ apiSetting, updateApiSetting }) {
    const [dataList, setDataList] = useState({});
    const [showSMTP, setShowSMTP] = useState(false);

    useEffect(() => {
        setDataList(apiSetting);
    }, [apiSetting]);

    const labelWidth = 130;

    const handleClickShowSMTP = () => setShowSMTP((show) => !show);
    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };

    const handleCreate = (property, event) => {
        const inputFormCopy = { ...dataList };
        inputFormCopy[property] = event.target.value || "";

        setDataList(inputFormCopy);
        updateApiSetting(inputFormCopy);
    };

    return (
        <Paper>
            <Box p={3}>
                <Typography variant="h5" mb={3} fontWeight="fontWeightMedium">
                    SMTP Settings
                </Typography>
                <Box display="flex" mb={2}>
                    <Typography
                        display="flex"
                        alignItems="center"
                        pr={4}
                        sx={{ minWidth: labelWidth }}
                    >
                        Email
                    </Typography>
                    <TextField
                        onChange={(event) => handleCreate("smtp_email", event)}
                        value={dataList?.smtp_email}
                        size="small"
                        id="email"
                        variant="outlined"
                        fullWidth
                    />
                </Box>
                <Box display="flex" mb={2}>
                    <Typography
                        display="flex"
                        alignItems="center"
                        justifyContent="start"
                        pr={4}
                        sx={{ minWidth: labelWidth }}
                    >
                        Username
                    </Typography>
                    <TextField
                        size="small"
                        id="username"
                        value={dataList?.smtp_user}
                        onChange={(event) => handleCreate("smtp_user", event)}
                        variant="outlined"
                        fullWidth
                    />
                </Box>

                <Box display="flex" mb={2}>
                    <Typography
                        display="flex"
                        alignItems="center"
                        justifyContent="start"
                        pr={4}
                        sx={{ minWidth: labelWidth }}
                    >
                        Password
                    </Typography>
                    <OutlinedInput
                        size="small"
                        id="password"
                        type={showSMTP ? "text" : "password"}
                        value={dataList?.smtp_pass}
                        onChange={(e) => handleCreate("smtp_pass", e)}
                        fullWidth
                        endAdornment={
                            <InputAdornment position="end">
                                <IconButton
                                    onClick={handleClickShowSMTP}
                                    onMouseDown={handleMouseDownPassword}
                                    edge="end"
                                >
                                    {!showSMTP ? <VisibilityOff /> : <Visibility />}
                                </IconButton>
                            </InputAdornment>
                        }
                    />
                </Box>

                <Box display="flex" mb={2}>
                    <Typography
                        display="flex"
                        alignItems="center"
                        justifyContent="start"
                        pr={4}
                        sx={{ minWidth: labelWidth }}
                    >
                        Port
                    </Typography>
                    <TextField
                        size="small"
                        id="port"
                        type="text"
                        value={dataList?.smtp_port}
                        onChange={(event) => handleCreate("smtp_port", event)}
                        variant="outlined"
                        fullWidth
                    />
                </Box>
                <Box display="flex" mb={2}>
                    <Typography
                        display="flex"
                        alignItems="center"
                        justifyContent="start"
                        pr={4}
                        sx={{ minWidth: labelWidth }}
                    >
                        Host
                    </Typography>
                    <TextField
                        size="small"
                        id="host"
                        type="text"
                        value={dataList?.smtp_host}
                        onChange={(event) => handleCreate("smtp_host", event)}
                        variant="outlined"
                        fullWidth
                    />
                </Box>
            </Box>
        </Paper>
    );
}
